import request from '../util/http'
import { saveAs } from 'file-saver'
export const queryOrderData = (data) =>
  request({
    url: '/zcjf/biz/guarantee/order/queryOrderData',
    method: 'get',
    params: data,
  })

export const queryOrderDetail = (id) =>
  request({
    url: '/zcjf/biz/guarantee/order/viewOrder',
    method: 'get',
    params: {
      orderId: id,
    },
  })

export const queryOrderByOuterOrderNo = (id) =>
  request({
    url: '/zcjf/biz/guarantee/order/queryOrderByOuterOrderNo',
    method: 'get',
    params: {
      outerOrderNo: id,
    },
  })

  /**
   * 通过外部订单号获取登录手机号
   * @param {*} outerOrderNo
   * @returns
   */
  export const queryLoginMobileByOuterOrderNo = (outerOrderNo) =>
  request({
    url: '/zcjf/biz/guarantee/order/queryLoginMobileByOuterOrderNo',
    method: 'get',
    params: {
      outerOrderNo: outerOrderNo,
    },
  })

export const queryPayStatus = (id) =>
  request({
    url: '/zcjf/biz/guarantee/order/getOrderPayStatus',
    method: 'get',
    params: {
      orderId: id,
    },
  })

export const queryInvoice = () =>
  request({
    url: '/zcjf/biz/guarantee/invoice/my/list',
    method: 'get',
  })

export const queryInvoiceByTaxNumber = (params) =>
  request({
    url: '/zcjf/biz/guarantee/invoice/getByTaxNumber',
    method: 'get',
    params,
  })

export const createInvoice = (data) =>
  request({
    url: '/zcjf/biz/guarantee/invoice/alterData',
    method: 'post',
    data,
  })

export const createIssueInvoice = (data) =>
  request({
    url: '/zcjf/biz/guarantee/invoice/issue',
    method: 'post',
    data,
  })

export const telegraphicSubmit = (data) =>
  request({
    url: '/zcjf/biz/guarantee/electronic/telegraphicSubmit',
    method: 'post',
    data,
  })

  export const deleteInvoiceByTaxNumber = (params) =>
  request({
    url: '/zcjf/biz/guarantee/invoice/deleteInvoice',
    method: 'post',
    params,
  })

//查询对接平台
export const queryApiAccessConfig = (id) =>
request({
  url: '/zcjf/biz/guarantee/order/queryApiAccessConfig',
  method: 'get',
  params: {
    orderId: id,
  },
})

// 上传承诺书
export const uploadUndertaking = (params) => {
  return request({
    url: '/zcjf/biz/guarantee/order/uploadUndertaking',
    method: 'get',
    params
  })
}

// 取消订单
export const cancelOrder = (id) =>
  request({
    url: '/zcjf/biz/guarantee/order/cancelOrder',
    method: 'get',
    params: {
      orderId: id,
    },
  })

// 构建安全访问链接
export const buildSecureUrl = (params) =>
  request({
    url: '/zcjf/biz/guarantee/gxzxdb/buildSecureUrl',
    method: 'get',
    params,
  })